import { render, staticRenderFns } from "./ConversationsIvr.vue?vue&type=template&id=4e72c120&scoped=true&"
import script from "./ConversationsIvr.vue?vue&type=script&lang=js&"
export * from "./ConversationsIvr.vue?vue&type=script&lang=js&"
import style0 from "./ConversationsIvr.vue?vue&type=style&index=0&id=4e72c120&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72c120",
  null
  
)

export default component.exports